import React, { useState, useEffect } from 'react';
import TopBar from '../../components/topBar';
import '../../styles/globalStyles.css';
import '../../styles/projectPageStyles.css';

const images = [
  { src: '/projects/rail-cart/rail-cart-front.jpg', alt: 'Rail Cart Front' },
  { src: '/projects/rail-cart/rail-cart-back.jpg', alt: 'Rail Cart Back' },
  { src: '/projects/rail-cart/rail-cart-1.jpg', alt: 'Rail Cart' },
];

const RailCartPage = () => {
  const [lightboxSrc, setLightboxSrc] = useState(null);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') setLightboxSrc(null); };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  return (
    <div className="projectPage">
      <TopBar />

      <div className="projectHero">
        <h1 className="projectTitle">Rail Cart</h1>
      </div>

      <div className="mediaSection">
        <div className="videoSection">
          <p className="sectionLabel">Videos</p>
          <div className="videoGrid double">
            <div className="videoWrapper">
              <video className="projectVideo" controls playsInline>
                <source src="/projects/rail-cart/rail-cart-video-1.mp4" type="video/mp4" />
              </video>
            </div>
            <div className="videoWrapper">
              <video className="projectVideo" controls playsInline>
                <source src="/projects/rail-cart/rail-cart-video-2.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>

        <div className="imageSection">
          <p className="sectionLabel">Photos</p>
          <div className="imageGrid">
            {images.map((img, i) => (
              <div key={i} className="imageWrapper" onClick={() => setLightboxSrc(img.src)}>
                <img className="projectImage" src={img.src} alt={img.alt} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {lightboxSrc && (
        <div className="lightbox" onClick={() => setLightboxSrc(null)}>
          <button className="lightboxClose" onClick={() => setLightboxSrc(null)}>×</button>
          <img
            className="lightboxImage"
            src={lightboxSrc}
            alt="expanded"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default RailCartPage;
